import React, { Component } from 'react'
import Slider from 'react-slick'

class Carousel extends Component {

	render() {
		const { className, options = {}, children } = this.props

		// default settings that could be overriden by `options`
		const settings = {
			dots: true,
			arrows: false,
			infinite: false,
			autoplay: false,
			speed: 500,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
                        slidesToShow: 1,
                        infinite: true,
                        autoplay: true
					}
				}
			]
		}

		// merged settings object
		const mergedSettings = {
			...settings,
			...options
		}
		return <Slider
			{ ...mergedSettings }
			className={className} >
			{children}
		</Slider>
	}
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/Carousel.js